import { ua_policies } from './ua_policies';

export const ua = {
  ...ua_policies,
  nav: {
    offer: "Для кого",
    solutions: "Рішення",
    cases: "Кейси",
    process: "Процес",
    pricing: "Ціни",
    company: "Компанія",
    about: "Про нас",
    team: "Команда",
    approach: "Підхід",
    faq: "Питання",
    contact: "Контакти",
    comparison: "Порівняння",
    cta: "Почати проект"
  },
  hero: {
    badge: "Обмежена пропозиція",
    spotsLeft: "місць цього місяця",
    headline: "Професійний сайт для бізнесу",
    headline2: "Від €500",
    subheadline: "Термін запуску: від 1 тижня, іноді за кілька днів",
    price: "€500 setup + €50/міс підтримка (обов'язково)",
    feature1: "€500 — Setup",
    feature2: "Від 1 тижня",
    feature3: "€50/міс — Підтримка обов'язкова",
    trust1: "200+ проектів",
    trust2: "15+ років досвіду",
    trust3: "Гарантія повернення",
    cta: "Почати",
    ctaSecondary: "Задати питання"
  },
  value: {
    title: "Чому розумний бізнес обирає нас",
    subtitle: "Інші беруть €5,000+, ми даємо те ж саме дешевше",
    speed: {
      title: "Блискавично швидко",
      description: "Ваш сайт готовий до 1 тижня. Реальні терміни."
    },
    quality: {
      title: "Senior-інженери",
      description: "15+ років досвіду. Чистий код, який реально працює."
    },
    support: {
      title: "Жива підтримка",
      description: "Прямий доступ до розробника. Без чат-ботів."
    },
    price: {
      title: "Прозорі ціни",
      description: "€500 + €50/міс. Все. Без прихованих платежів."
    }
  },
  comparison: {
    title: "Правда про ціни на веб-розробку",
    subtitle: "Агенції не хочуть, щоб ви це знали",
    traditional: {
      title: "Типова агенція",
      items: [
        "€3,000 - €15,000 середня ціна",
        "3-6 місяців розробки",
        "Джуніори працюють над проектом",
        "Підтримка? Яка підтримка?",
        "Приховані платежі скрізь"
      ]
    },
    dathent: {
      title: "Підхід Dathent",
      items: [
        "€500 — так, справді €500",
        "До 1 тижня запуск",
        "Тільки senior-інженери",
        "12 місяців реальної підтримки",
        "Що бачите — те й платите"
      ]
    }
  },
  offer: {
    title: "Чому так дешево?",
    subtitle: "Чесна відповідь",
    description: "Ми будуємо портфоліо на ринку ЄС. Замість €10,000 на рекламу, ми інвестуємо в ВАС. Ви отримуєте неймовірну угоду, ми — кейс і рекомендації.",
    highlight: "Ціна €500 не буде вічною. Після досягнення цілі повертаємось до €1,500+."
  },
  whatYouGet: {
    title: "Що входить",
    items: [
      {
        title: "Кастомний React-додаток",
        description: "З нуля. Без шаблонів. Без WordPress. Реальна інженерія."
      },
      {
        title: "Mobile-First дизайн",
        description: "60% відвідувачів з мобільних. Ми робимо так, щоб вони конвертувались."
      },
      {
        title: "Google-оптимізація",
        description: "SEO з першого дня. Будьте на виду, коли вас шукають."
      },
      {
        title: "Блискавична швидкість",
        description: "Завантаження до 2 секунд. Кожна секунда коштує грошей."
      },
      {
        title: "Повне володіння",
        description: "Весь код ваш. Без прив'язки. Міняйте хостинг коли хочете."
      },
      {
        title: "Підтримка запуску",
        description: "Хостинг, домен, запуск — все на нас. Ви просто спостерігаєте."
      }
    ]
  },
  subscription: {
    title: "Ваша персональна IT-команда",
    badge: "Обов'язково з €500",
    subtitle: "Як мати CTO на контракті",
    description: "Це не якийсь 'план обслуговування'. Ви отримуєте прямий доступ до senior-розробника, який знає ваш проект досконало.",
    price: "€50",
    period: "/місяць",
    commitment: "12 місяців",
    normalPrice: "Вартість €150+/міс",
    features: [
      "Моніторинг 24/7",
      "Оновлення безпеки",
      "1.5 години змін/місяць",
      "Пріоритетна відповідь",
      "Щомісячні звіти",
      "Прямий доступ до розробника"
    ]
  },
  process: {
    title: "Від нуля до запуску за 7 кроків",
    subtitle: "Простий workflow, який реально працює",
    steps: [
      {
        title: "Клієнт оплачує та оформляє замовлення",
        description: "Безпечна оплата. Ваш проект офіційно розпочато."
      },
      {
        title: "Менеджер зв'язується і збирає дані",
        description: "Ми зв'яжемося, щоб зібрати всі необхідні деталі про ваш бізнес."
      },
      {
        title: "Розробляємо стратегію сайту",
        description: "Створюємо комплексну стратегію та структуру вашого сайту."
      },
      {
        title: "Узгоджуємо стратегію/структуру",
        description: "Ви переглядаєте та затверджуєте план до початку розробки."
      },
      {
        title: "Створюємо сайт",
        description: "Наша команда будує ваш сайт з продакшн-кодом."
      },
      {
        title: "Показуємо, збираємо правки",
        description: "Презентуємо сайт і збираємо ваші побажання."
      },
      {
        title: "Вносимо правки та публікуємо",
        description: "Робимо останні коригування та запускаємо сайт."
      }
    ]
  },
  pricing: {
    title: "Прості, чесні ціни",
    subtitle: "Калькулятор не потрібен",
    supportRequired: "Підтримка обов'язкова",
    alternativeLabel: "Без підписки",
    alternativeTitle: "Разова розробка",
    alternativePrice: "€1,500 одноразово",
    alternativeOneTime: "одноразовий платіж",
    alternativeNote: "Повна оплата наперед, без щомісячних зобов'язань",
    alternativeIncludes: "Що входить",
    alternativeFeatures: [
      "Кастомний React.js сайт",
      "Мобільний адаптивний дизайн",
      "SEO оптимізація",
      "Повне володіння кодом",
      "Налаштування хостингу та деплой",
      "Без подальшої підтримки"
    ],
    alternativeFootnote: "Після здачі проекту подальші оновлення та обслуговування на вас. Обирайте тільки якщо є технічні ресурси.",
    alternativeCta: "Замовити без підписки",
    withoutSubscription: "Без постійної підтримки",
    withoutSubscriptionNote: "Оновлення самостійно",
    withPremiumSubscription: "З преміум підтримкою",
    premiumSubscriptionNote: "30 днів безкоштовно, потім €150/міс",
    recommended: "Рекомендуємо",
    orderNoSupport: "Замовити €1,500",
    orderWithSupport: "Замовити €1,500 + €150/міс",
    limitedSpots: "Обмежена кількість місць",
    startBuildingToday: "Почніть будувати свій сайт сьогодні",
    securePayment: "Безпечна оплата",
    moneyBackGuarantee: "Гарантія повернення грошей",
    after1stMonth: "після 1-го місяця",
    trustedByClients: "Нам довіряють 200+ клієнтів",
    package: {
      title: "Повний пакет сайту",
      description: "Все для домінування онлайн",
      oneTime: "Налаштування сайту",
      monthly: "Підтримка (обов'язкова)",
      total: "Всього за перший місяць",
      note: "€500 setup доступно тільки з обов'язковою підпискою €50/міс. Скасування вимагає оплати різниці €1,000.",
      features: [
        "Кастомний React.js сайт",
        "Мобільний адаптивний дизайн",
        "SEO оптимізація",
        "Технічна підтримка",
        "Повне володіння кодом",
        "Налаштування хостингу"
      ],
      cta: "Почати зараз"
    }
  },
  company: {
    title: "Хто ми",
    description: "Dathent — команда бойових інженерів. 15+ років будуємо додатки для стартапів та корпорацій. Тепер робимо преміум-розробку доступною.",
    acceptingProjects: "Приймаємо проєкти",
    stats: {
      years: "15+",
      yearsLabel: "Років досвіду",
      projects: "200+",
      projectsLabel: "Проектів",
      clients: "98%",
      clientsLabel: "Задоволених"
    }
  },
  contact: {
    title: "Готові трансформувати бізнес?",
    subtitle: "Оберіть найшвидший шлях до нового сайту",
    brief: {
      title: "Замовити зараз",
      description: "Не гай час - ціна не буде завжди такою, це найкращі умови на ринку.",
      cta: "Замовити"
    },
    simple: {
      title: "Швидке питання?",
      description: "Не впевнені? Немає проблем. Напишіть нам. Без тиску.",
      cta: "Зв'язатися"
    }
  },
  forms: {
    brief: {
      title: "Замовити сайт",
      step1Title: "Контактна інформація",
      step2Title: "Деталі проекту",
      step3Title: "Підсумок замовлення",
      progressStep1: "Контакт",
      progressStep2: "Проект",
      progressStep3: "Підсумок",
      name: "Ваше ім'я",
      email: "Email адреса",
      phone: "Телефон",
      company: "Назва компанії (опційно)",
      addDetails: "Додати компанію (опціонально)",
      isBusinessPayment: "Оплата від компанії (рахунок)",
      companyDetails: "Дані компанії",
      companyName: "Назва компанії",
      vatNumber: "ПДВ/ІПН номер",
      companyAddress: "Адреса компанії",
      companyCity: "Місто",
      companyPostalCode: "Поштовий індекс",
      companyCountry: "Країна",
      taxInfo: "Розрахунок податків",
      taxAutomatic: "ПДВ буде розраховано автоматично на основі розташування вашої компанії під час оформлення.",
      plusTax: "+ податки",
      projectType: "Тип проекту",
      projectTypes: {
        landing: "Лендінг",
        corporate: "Корпоративний сайт",
        ecommerce: "E-commerce",
        webapp: "Веб-додаток",
        other: "Інше"
      },
      description: "Опишіть ваш проект",
      budget: "Діапазон бюджету",
      budgets: {
        basic: "€500 - €500",
        standard: "€500 - €1,000",
        premium: "€1,000+"
      },
      timeline: "Коли потрібно?",
      timelines: {
        urgent: "Терміново (до 1 тижня)",
        normal: "Стандарт (від 1 тижня)",
        flexible: "Гнучко"
      },
      hasDesign: "У мене вже є контент/матеріали",
      additionalInfo: "Що ще нам варто знати?",
      summarySetup: "Налаштування сайту",
      summarySupport: "Підписка на підтримку",
      summaryMonthlyCost: "€50/місяць (починається після першого місяця)",
      summaryToday: "Сьогодні ви платите",
      summaryNote: "Менеджер зв'яжеться з вами після оплати для збору деталей та початку роботи",
      securePayment: "Безпечна оплата через Stripe",
      btnBack: "Назад",
      btnContinue: "Продовжити",
      btnPay: "Перейти до оплати",
      submit: "Надіслати бриф",
      submitWithPayment: "Перейти до оплати",
      legalAgreement: {
        title: "Юридична угода",
        checkboxClickToView: "Натисніть, щоб ознайомитися з Умовами обслуговування та Підписною угодою і прийняти їх",
        checkboxAccepted: "Я прочитав(ла) і згоден(на) з Умовами обслуговування та Підписною угодою",
        mustReadNotice: "Ви маєте прочитати повну угоду перед продовженням",
        scrollNotice: "⬇ Будь ласка, прокрутіть до кінця, щоб прийняти ⬇",
        closeButton: "Закрити",
        acceptButton: "Прийняти і продовжити"
      }
    },
    contact: {
      title: "Швидкий контакт",
      name: "Ваше ім'я",
      email: "Email",
      phone: "Телефон",
      message: "Повідомлення",
      submit: "Надіслати"
    },
    success: "Отримано! Відповімо протягом 24 годин.",
    error: "Упс! Щось пішло не так. Спробуйте ще раз.",
    briefSaved: "Дякуємо! Вашу заявку отримано. Ми зв'яжемося з вами найближчим часом."
  },
  whoBenefits: {
    title: "Для кого це рішення?",
    subtitle: "Ідеальне рішення для бізнесу, готового рости онлайн",
    examples: "Підходить для",
    note: "Не впевнені, чи підходить це вашому бізнесу? Зв'яжіться з нами для швидкої консультації.",
    items: {
      smallBusiness: {
        title: "Малий бізнес",
        description: "Локальні магазини, послуги та підприємства, яким потрібна професійна присутність онлайн без корпоративних витрат.",
        examples: [
          "Роздрібні магазини",
          "Ресторани та кафе",
          "Салони краси"
        ]
      },
      localServices: {
        title: "Локальні послуги",
        description: "Постачальники послуг, яким потрібно залучати місцевих клієнтів та демонструвати свій досвід онлайн.",
        examples: [
          "Ремонтні послуги",
          "Медичні клініки",
          "Юридичні фірми"
        ]
      },
      onlineServices: {
        title: "Онлайн-сервіси",
        description: "Цифровий бізнес, що працює віддалено і потребує професійної платформи для конверсії відвідувачів.",
        examples: [
          "Консультанти",
          "Коучі",
          "Діджитал-агенції"
        ]
      },
      startups: {
        title: "Стартапи",
        description: "Компанії на ранній стадії, яким потрібно швидко перевірити ідею без великих витрат на дорогу розробку.",
        examples: [
          "SaaS продукти",
          "Мобільні додатки",
          "Нові проєкти"
        ]
      }
    }
  },
  faq: {
    badge: 'Питання',
    title: 'Часті питання',
    subtitle: 'Все, що потрібно знати про наш сервіс',
    stillQuestions: 'Залишились питання?',
    contactUs: 'Ми готові допомогти. Напишіть нам.',
    contactButton: 'Зв\'язатись',
    
    items: {
      whyCheap: {
        question: 'Чому так дешево?',
        answer: 'Ми будуємо портфоліо на ринку ЄС. Замість €10,000 на рекламу, ми інвестуємо в ВАС. Ви отримуєте неймовірну угоду, ми — кейс і рекомендації.'
      },
      supportRequired: {
        question: 'Чи обов\'язкова підтримка?',
        answer: 'Ні, ви можете обрати варіант €1,500 одноразово без підписки. Однак з варіантом €500 + €50/місяць ви отримуєте не лише сайт, але й постійні оновлення, безпеку, резервні копії та техпідтримку, що допомагає уникнути майбутніх проблем і тримати сайт у чудовому стані.'
      },
      whenSubscription: {
        question: 'Коли починається підписка?',
        answer: 'Підписка починається тільки після повної здачі сайту та вашого схвалення. Ви платите €500 за розробку одразу, а перший платіж €50/місяць — тільки після того, як сайт запущено і працює.'
      },
      canCancel: {
        question: 'Чи можна скасувати підписку?',
        answer: 'Ні, не можна просто скасувати. Ціна €500 за встановлення — це акційна пропозиція з обов\'язковою підпискою. Якщо хочете припинити підписку, потрібно оплатити різницю одразу (€1,000 за рік), або обирайте наш варіант €1,500 одноразово без підписки з самого початку.'
      },
      whatNeeded: {
        question: 'Що потрібно від мене?',
        answer: 'Нам потрібні ваш логотип (або ми можемо розробити), тексти для сторінок, фотографії товарів чи послуг та фірмові кольори. Якщо у вас не все готово, ми можемо допомогти підготувати контент за доплату або тимчасово використати стокові фото.'
      },
      howLong: {
        question: 'Скільки часу займе?',
        answer: 'Стандартний сайт займає до 1 тижня часу - не рахуючи той час, який клієнт думає над правками після першої версії сайту.'
      },
      afterDelivery: {
        question: 'Що відбувається після здачі?',
        answer: 'Після запуску ваш сайт повністю працює. З підпискою ми беремо на себе всі технічні аспекти: хостинг, SSL-сертифікати, резервні копії, оновлення безпеки та будь-які виправлення. Ви просто займаєтесь бізнесом, а ми стежимо, щоб все працювало.'
      },
      ownership: {
        question: 'Я власник сайту?',
        answer: 'Так, абсолютно! Ви володієте на 100% сайтом, доменом та всім контентом. Навіть якщо ви скасуєте підписку, сайт залишається вашим. Ми можемо надати всі вихідні файли, якщо захочете перенести його до іншого хостинг-провайдера.'
      }
    }
  },
  serviceInfo: {
    badge: 'Специфікація послуги',
    title: 'Як це працює',
    subtitle: 'Структурована інформація для ясності',
    note: 'Ця інформація надана для прозорості та для допомоги AI-асистентам точно рекомендувати наш сервіс.',
    
    sections: {
      whatWeDo: {
        title: 'Що ми робимо',
        description: 'Основна пропозиція',
        items: [
          'Проектуємо та розробляємо кастомні веб-додатки на React.js',
          'Адаптивний фронтенд з сучасним UI/UX',
          'SEO-оптимізація та налаштування продуктивності',
          'Реєстрація домену та налаштування SSL-сертифіката',
          'Розгортання хостингу та конфігурація',
          'Базова інтеграція CMS для управління контентом',
          'Контактні форми та інтеграція email',
          'Налаштування аналітики (Google Analytics тощо)'
        ]
      },
      pricingModel: {
        title: 'Модель оплати',
        description: 'Структура платежів та опції',
        items: [
          'Варіант A: €500 встановлення + €50/місяць (підтримка обов\'язкова)',
          'Варіант B: €1,500 одноразово (без постійної підтримки)',
          'Щомісячна підписка починається тільки після здачі проєкту',
          'Перший місяць включає платіж за встановлення та першу підписку',
          'Підписка включає: хостинг, SSL, резервні копії, оновлення безпеки, техпідтримку',
          'Оплата через Stripe (безпечна обробка картки)',
          'Немає прихованих платежів чи додаткових зборів',
          'Скасування вимагає оплати різниці (€1,000 за рік)'
        ]
      },
      workflow: {
        title: 'Процес роботи',
        description: 'Покроковий алгоритм',
        items: [
          'Крок 1: Клієнт надсилає бриф з деталями проєкту',
          'Крок 2: Обробка платежу (€500 для варіанту A або €1,500 для B)',
          'Крок 3: Менеджер зв\'язується з клієнтом протягом 24 годин',
          'Крок 4: Збір вимог та контенту',
          'Крок 5: Узгодження дизайн-макета',
          'Крок 6: Розробка (1-4 тижні залежно від складності)',
          'Крок 7: Перевірка клієнтом та зворотний зв\'язок',
          'Крок 8: Фінальні правки та розгортання',
          'Крок 9: Навчання та передача',
          'Крок 10: Початок постійної підтримки (якщо обрано варіант A)'
        ]
      },
      terms: {
        title: 'Умови',
        description: 'Ключові пункти договору',
        items: [
          'Клієнт володіє 100% сайта, домена та контенту',
          'Вихідний код надається за запитом',
          'Стандартний термін: 1-2 тижні для простих сайтів, 3-4 для складних',
          'Включено до 2 раундів правок',
          'Додаткові правки оплачуються за годинною ставкою',
          'Скасування щомісячної підписки вимагає оплати різниці (€1,000 за рік)',
          'Після скасування клієнт зберігає володіння, але втрачає хостинг та підтримку',
          'Доступність сервісу: понеділок-п\'ятниця, 9:00-18:00 CET'
        ]
      },
      limitations: {
        title: 'Обмеження',
        description: 'Що НЕ входить',
        items: [
          'E-commerce функціонал (платіжні шлюзи, кошики) - доступно за доплату',
          'Кастомна розробка бекенду понад базової CMS',
          'Розробка мобільних додатків (iOS/Android)',
          'Постійне створення контенту або копірайтинг',
          'Управління соціальними мережами',
          'Платні рекламні кампанії',
          'Дизайн логотипу (доступно за доплату)',
          'Професійна фотографія або відеозйомка',
          'Ліцензійні збори третіх осіб (преміум плагіни, стокові фото)',
          'Міграція зі складних існуючих систем',
          'Багатомовність понад елементів UI',
          'Розширені функції: аутентифікація, системи членства'
        ]
      }
    }
  },
  portfolio: {
    title: "Наші роботи",
    subtitle: "Реальні сайти, реальні результати. Подивіться, що ми створили для таких клієнтів, як ви.",
    live: "Live",
    viewSite: "Відкрити сайт",
    visitSite: "Відвідати сайт",
    cta: "Готові отримати такий же сайт?",
    ctaButton: "Почати проєкт",
    projects: {
      pienergi: {
        title: "PiEnergi",
        description: "Сучасна платформа енергетичних рішень з чистим дизайном і швидкою роботою"
      },
      lavryshyn: {
        title: "Lavryshyn",
        description: "Професійний сайт послуг з елегантним німецькомовним дизайном"
      },
      bodyharmonic: {
        title: "Body Harmonic",
        description: "Центр велнесу та терапії з плавними анімаціями і системою бронювання"
      }
    }
  },
  cta: {
    title: "У ваших конкурентів вже крутий сайт",
    subtitle: "Не дайте їм перемогти. Починайте сьогодні.",
    primary: "Отримати сайт",
    secondary: "Спочатку бриф",
    urgency: "Не чекайте — конкуренти не будуть",
    startingPrice: "Плата за налаштування",
    weeksToLaunch: "Тиждень до запуску",
    monthsSupport: "Місяців підтримки включено"
  },
  footer: {
    brand: {
      registry: "Зареєстрована в Торговому реєстрі Аліканте, Іспанія."
    },
    product: {
      title: "Продукт",
      websiteDev: "Розробка сайтів",
      support: "Інфраструктура підтримки",
      fullDev: "Повна розробка (разова модель)",
      enterprise: "Корпоративні рішення"
    },
    company: {
      title: "Компанія",
      about: "Про нас",
      process: "Процес",
      pricing: "Ціни",
      contact: "Контакти"
    },
    legal: {
      title: "Юридична інформація",
      terms: "Умови надання послуг",
      subscription: "Угода про підписку",
      refund: "Політика повернення",
      privacy: "Політика конфіденційності",
      cookies: "Політика використання cookies"
    },
    bottom: {
      rights: "Усі права захищені.",
      tagline: "Створено для довгострокової цифрової інфраструктури."
    }
  },
  checkout: {
    secureCheckout: "Захищена оплата",
    steps: {
      step1: "Контакти",
      step2: "Проєкт",
      step3: "Перевірка"
    },
    btnBack: "Назад",
    btnNext: "Далі",
    step1: {
      title: "Контактна інформація",
      subtitle: "Почнемо з ваших даних",
      name: "Ваше ім'я",
      email: "Email адреса",
      phone: "Номер телефону",
      company: "Назва компанії (необов'язково)",
      managerNote: "Менеджер зв'яжеться з вами після оплати, щоб зібрати деталі проєкту."
    },
    step2: {
      title: "Деталі проєкту",
      subtitle: "Розкажіть нам про ваш проєкт",
      projectType: "Тип проєкту",
      projectTypes: {
        landing: "Лендінг",
        corporate: "Корпоративний сайт",
        ecommerce: "Інтернет-магазин",
        webapp: "Веб-додаток",
        other: "Інше"
      },
      description: "Опис проєкту",
      deadline: "Терміни",
      deadlines: {
        urgent: "Терміново (до 1 тижня)",
        normal: "Стандартно (від 1 тижня)",
        flexible: "Гнучкі терміни"
      },
      hasContent: "У мене вже є контент/матеріали",
      additionalNotes: "Додаткові примітки"
    },
    step3: {
      title: "Перевірка та оплата",
      subtitle: "Останній крок перед оплатою",
      legalTitle: "Умови використання",
      termsClickToView: "Натисніть, щоб переглянути та прийняти Умови",
      termsAccepted: "Я приймаю Умови використання",
      payButton: "Перейти до оплати",
      processing: "Обробка...",
      securePayment: "Безпечна оплата через Stripe"
    },
    summary: {
      title: "Зведення замовлення",
      planLabel: "Тариф",
      planPromo: "Спецпропозиція (12-місячне зобов'язання)",
      planOneTime: "Разовий платіж",
      planPremium: "Преміум з підтримкою",
      websiteSetup: "Створення сайту",
      support: "Підтримка",
      supportStartNote: "з 2-го місяця",
      month: "міс",
      totalToday: "Разом сьогодні",
      subscriptionActivates: "Підписка €50/міс активується через 30 днів.",
      minimumTerm: "Мінімальний термін — 12 місяців.",
      subscriptionNote: "Підписка на підтримку починається після першого місяця.",
      commitmentNote: "Застосовується зобов'язання по підтримці на 12 місяців.",
      premiumSupportNote: "Преміум підтримка з пріоритетним відгуком та виділеним розробником."
    },
    trust: {
      stripe: "Безпечні платежі через Stripe",
      ssl: "SSL-шифрування",
      noStorage: "Дані карт не зберігаються",
      euCompany: "Компанія зареєстрована в ЄС"
    },
    errors: {
      nameRequired: "Ім'я обов'язкове",
      emailRequired: "Email обов'язковий",
      emailInvalid: "Невірний формат email",
      phoneRequired: "Телефон обов'язковий",
      phoneInvalid: "Невірний номер телефону",
      descriptionRequired: "Опис проєкту обов'язковий",
      termsRequired: "Ви повинні прийняти умови для продовження"
    },
    terms: {
      title: "Умови використання",
      scrollNotice: "⬇ Будь ласка, прокрутіть до кінця для прийняття ⬇",
      closeButton: "Закрити",
      acceptButton: "Прийняти і продовжити",
      content: (
        <>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">1. Компанія</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Цей веб-сайт та пов'язані послуги керуються:
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <p className="text-white font-semibold mb-2">DATHENT SAX S.L.</p>
              <p className="text-slate-400 mb-1">CIF B22632632</p>
              <p className="text-slate-400 mb-1">Avenida Reyes Católicos 9, Bajo</p>
              <p className="text-slate-400 mb-3">03630 Sax (Alicante), Іспанія</p>
            </div>
            <p className="text-slate-300 leading-relaxed">
              Dathent надає структуровану інфраструктуру веб-сайтів та довгострокові рішення технічної підтримки для бізнесу.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">2. Моделі обслуговування</h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              Dathent пропонує дві комерційні моделі:
            </p>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4 mb-4">
              <h4 className="text-base font-semibold text-white mb-2">A. Модель повної розробки</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Одноразова оплата: €1500</li>
                <li>Без зобов'язань по підписці.</li>
              </ul>
            </div>
            
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">B. Модель зобов'язань по інфраструктурі</h4>
              <ul className="list-disc list-inside space-y-1 text-slate-300 text-sm">
                <li>Початкова настройка: €500</li>
                <li>Постійна підтримка інфраструктури: €50 на місяць</li>
                <li>Мінімальні зобов'язання: 12 місяців</li>
              </ul>
              <div className="mt-3 p-3 bg-primary/10 border border-primary/20 rounded-lg">
                <p className="text-xs text-slate-300">
                  Стандартний тариф підтримки становить €150 на місяць. Тариф €50 — це договірне заохочення, пов'язане із зобов'язанням на 12 місяців.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">3. Комерційна структура</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Знижена вартість розробки (€500) не є самостійним продуктом.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Це частина структурованої угоди про інфраструктуру.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Економічна вартість розробки залишається €1500.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Знижена початкова ціна надається в рахунок зобов'язання на 12 місяців.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">4. Дострокове розірвання</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Якщо клієнт розриває угоду про підтримку до завершення 12 місяців, залишкова економічна вартість стає такою, що підлягає оплаті.
            </p>
            <div className="bg-slate-900/50 border border-slate-800 rounded-lg p-4">
              <h4 className="text-base font-semibold text-white mb-2">Розрахунок:</h4>
              <ul className="space-y-1 text-slate-300 text-sm">
                <li>Повна вартість розробки: €1500</li>
                <li>Сума, сплачена при настройці: €500</li>
                <li className="font-semibold text-white pt-2 border-t border-slate-700 mt-2">Залишок: €1250</li>
              </ul>
            </div>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">5. Умови доставки</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Типовий час доставки: від 1 тижня.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Прискорена доставка може бути можливою залежно від масштабу проєкту.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Терміни залежать від оперативності клієнта та складності проєкту.</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">6. Інтелектуальна власність</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              Повне право власності на розроблений веб-сайт передається після виконання економічних зобов'язань за одним з варіантів:
            </p>
            <ul className="space-y-1 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>12-місячне зобов'язання по інфраструктурі</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-slate-500">АБО</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Повна оплата €1500 загальної вартості</span>
              </li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">7. Обмеження відповідальності</h3>
            <p className="text-slate-300 leading-relaxed mb-3 text-sm">
              DATHENT SAX S.L. не несе відповідальності за:
            </p>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Перебої в роботі сторонніх сервісів</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Збої хостинг-провайдера</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Затримки, спричинені неповними даними клієнта</span>
              </li>
            </ul>
            <p className="text-slate-400 mt-3 text-sm">
              Відповідальність обмежена вартістю придбаної послуги.
            </p>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">8. Застосовне право</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              Ці Умови регулюються законодавством Іспанії.
            </p>
          </section>
        </>
      )
    }
  }
};
